const CARD_THEMES = [
  { bgColor: '#ffe3ec', borderColor: '#f48aa6' },
  { bgColor: '#dbeafe', borderColor: '#93c5fd' },
  { bgColor: '#ffe4ef', borderColor: '#f9a8d4' },
  { bgColor: '#dcfce7', borderColor: '#86efac' },
  { bgColor: '#ffedd5', borderColor: '#fdba74' },
  { bgColor: '#dbeafe', borderColor: '#93c5fd' },
  { bgColor: '#f3e8ff', borderColor: '#c4b5fd' },
  { bgColor: '#fef3c7', borderColor: '#fcd34d' },
  { bgColor: '#ccfbf1', borderColor: '#5eead4' },
  { bgColor: '#ecfccb', borderColor: '#bef264' },
  { bgColor: '#ede9fe', borderColor: '#c4b5fd' },
  { bgColor: '#fef08a', borderColor: '#fde047' },
];

const EMOJI_AVATARS = ['🐰', '🦊', '🐻', '🐼', '🐨', '🦁', '🐯', '🐸', '🐧', '🦉', '🐝', '🦋'];

export function hashString(value, seed = 31) {
  const text = String(value || '');
  let hash = 0;
  for (let i = 0; i < text.length; i += 1) hash = (hash * seed + text.charCodeAt(i)) | 0;
  return Math.abs(hash);
}

export function avatarImageUrl(avatarId, size = 128) {
  if (!/^[a-z0-9_]+$/.test(String(avatarId || ''))) return null;
  return `/avatars/dandu-v1/${size}/${avatarId}.webp`;
}

export function getStudentAvatar(studentId, avatarId = null, starterEmoji = null) {
  const key = String(studentId || '');
  const theme = CARD_THEMES[hashString(key, 31) % CARD_THEMES.length];
  return {
    ...theme,
    avatar: starterEmoji || EMOJI_AVATARS[hashString(key, 37) % EMOJI_AVATARS.length],
    imageUrl: avatarImageUrl(avatarId),
  };
}

export { CARD_THEMES, EMOJI_AVATARS };
